import * as types from '../store/types';
import resources from '../helpers/resources';

const client = resources();

function setWarning(lang, id, data) {
  return {
    type: types.WARNING_FETCHED,
    payload: {
      id,
      lang,
      data,
    },
  };
}

function setDescription(lang, id, data) {
  return {
    type: types.DESCRIPTION_FETCHED,
    payload: {
      id,
      lang,
      data,
    },
  };
}

function setManual(lang, id, data) {
  return {
    type: types.MANUAL_FETCHED,
    payload: {
      id,
      lang,
      data,
    },
  };
}

export function fetchWarning(lang, id) {
  return async (dispatch) => {
    const resp = await client.getWarning(lang, id);

    dispatch(setWarning(lang, id, resp.data));

    return resp;
  };
}

export function fetchDescription(lang, id) {
  return async (dispatch) => {
    const resp = await client.getDescription(lang, id);

    dispatch(setDescription(lang, id, resp.data));

    return resp;
  };
}

export function fetchManual(lang, id) {
  return async (dispatch) => {
    const resp = await client.getManual(lang, id);

    dispatch(setManual(lang, id, resp.data));

    return resp;
  };
}
